import React from 'react'

const SwitchButtons = ({
  label1,
  label2,
  label3,
  labels = [],
  activeState,
  setActiveState,
  isDisabled = false
}) => {
  const isBoolean = typeof label1?.value === 'boolean'

  const activeClasses = `${isDisabled ? 'bg-primary/70' : 'bg-gradient'
    } text-white text-[10px] md:text-[12px]`
  const inactiveClasses = 'bg-transparent text-gray-700 text-[10px] md:text-[12px]'

  const isActive = labelValue => {
    return isBoolean
      ? activeState === labelValue
      : activeState === labelValue?.toLowerCase()
  }

  const handleClick = labelValue => {
    if (isDisabled) return
    setActiveState(isBoolean ? labelValue : labelValue?.toLowerCase())
  }

  return (
    <div className='flex border border-gray-300 h-[30px] rounded-lg w-full items-center overflow-hidden'>
      {labels && labels?.length > 0 ? (
        labels.map((label, index) => (
          <div
            key={index}
            className={`flex items-center justify-center w-full h-full  ${isActive(label?.value) ? activeClasses : inactiveClasses
              } ${label?.disabled ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer'}`}
            onClick={() => handleClick(label?.value)}
          >
            {label?.name}
          </div>
        ))
      ) : (
        <>
          <div
            className={`flex items-center justify-center w-full h-full cursor-pointer rounded-tl-md rounded-bl-md ${isActive(label1?.value) ? activeClasses : inactiveClasses
              }`}
            onClick={() => handleClick(label1?.value)}
          >
            {label1?.name}
          </div>

          <div
            className={`flex items-center justify-center w-full h-full cursor-pointer ${isActive(label2?.value) ? activeClasses : inactiveClasses
              }`}
            onClick={() => handleClick(label2?.value)}
          >
            {label2?.name}
          </div>

          {label3 && (
            <div
              className={`flex items-center justify-center w-full h-full cursor-pointer rounded-tr-md rounded-br-md ${isActive(label3?.value) ? activeClasses : inactiveClasses
                }`}
              onClick={() => handleClick(label3?.value)}
            >
              {label3?.name}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default SwitchButtons

// import React from 'react';

// const SwitchButtons = ({ label1, label2, activeState, setActiveState, isDisabled = false }) => {
//   return (
//     <div className='flex border border-gray-300 h-[30px] justify-between rounded-lg w-full items-center'>
//       <div
//         className={`flex items-center justify-center w-full h-full cursor-pointer ${
//           activeState === label1?.value?.toLowerCase()
//             ? `${isDisabled ? 'bg-primary/70' : 'bg-primary'}  text-white rounded-tl-md rounded-bl-md text-[12px]`
//             : 'bg-transparent text-gray-700'
//         }`}
//         onClick={isDisabled ? null : () => setActiveState(label1?.value?.toLowerCase())}
//       >
//         {label1?.name}
//       </div>
//       <div
//         className={`flex items-center justify-center w-full h-full cursor-pointer ${
//           activeState === label2?.value?.toLowerCase()
//             ? `${isDisabled ? 'bg-primary/70' : 'bg-primary'}  text-white rounded-tr-md rounded-br-md text-[12px]`
//             : 'bg-transparent text-gray-700 text-[12px]'
//         }`}
//         onClick={isDisabled ? null : () => setActiveState(label2?.value?.toLowerCase())}
//       >
//         {label2?.name}
//       </div>
//     </div>
//   );
// };

// export default SwitchButtons;
